import { apiMethod } from '../../shared';
import { APINames } from 'src/shared';

// 移除监听录屏的全局监听函数。
export function offScreenRecordingStateChanged() {
  apiMethod.off(APINames.Native.ON_SCREEN_RECORD_STATE_CHANGE);
}
